<template>
    <el-dialog
        :visible.sync="showObj.register"
        :modal-append-to-body=false
        :show-close=false>
        <div class="modal-title" v-show="!registerSuccess">注册账号</div>
        <div class="form register-form">
            <div class="ipts">
                <input v-model="email" v-show="!success && !registerSuccess" @blur="check()" class="ipt ipt-account" type="text" placeholder="手机号/电子邮箱">
                <div class="ipt-wrap" v-show="!success && !registerSuccess">
                    <input v-model="password" @blur="equal()" class="ipt ipt-pwd"
                        v-if="!visiable" type="password" placeholder="创建密码8-18位">
                    <input v-model="password" @blur="equal()" class="ipt ipt-pwd"
                        v-if="visiable" type="text" placeholder="创建密码8-18位">
                    <i @click="changeVisiable()" :class="{'text-icon': visiable}"></i>
                </div>
                <input v-show="!success && !registerSuccess" v-model="confirm" @blur="equal()" class="ipt ipt-pwd" type="password" placeholder="确认密码">
                <div class="verify-wrap" v-show="success">
                    <input class="ipt ipt-verify" type="text"
                        v-model="code" placeholder="验证码">
                    <span class="time" v-show="showCount">{{time}}s</span>
                    <span class="resend" v-show="!showCount" @click="submit(2)">重新发送</span>
                </div>
                <p class="form-warnning" v-show="error">{{error}}</p>
                <div class="register-success" v-show="registerSuccess">
                    <p class="success-tip">注册成功</p>
                    <!-- <p class="success-email">验证邮箱已发送至{{email}}</p> -->
                    <input class="btn btn-solid" type="button" value="确定" @click="init()">
                    <!-- <p class="success-resend">
                        没收到验证邮箱？请耐心等候，或
                        <span>重新发送{{time}}s</span>
                    </p> -->
                </div>
            </div>
            <div class="btns">
                <input @click="submit(1)" v-show="!success && !registerSuccess" class="btn btn-solid" type="button" name="" value="注册">
                <input @click="confirmAccount()" v-show="success" class="btn btn-solid" type="button" name="" value="完成">
                <input class="btn btn-hollow" v-show="success" type="button" value="取消" @click="showObj.register = false">
            </div>
        </div>
        <div class="modal-footer" v-show="!registerSuccess">
            <a href="javascript:;" @click="turnToModal('changePwd')">忘记密码</a>
            <a href="javascript:;" @click="turnToModal('login')">已有账号</a>
        </div>
        <div class="btn-close" @click="showObj.register = false"></div>
    </el-dialog>
</template>

<script>
    import user from '../../service/user.js';
    import axios from 'axios';

    export default {
        props: ["showObj"],
        data() {
            return {
                email: '',
                password: '',
                confirm: '',
                code: '',
                success: false,
                error: '',
                type: 'email',
                visiable: false,
                showCount: true,
                time: 60,
                registerSuccess: false
            };
        },
        methods: {
            init() {
                this.showObj.register = false;
                this.email= '';
                this.password= '';
                this.confirm= '';
                this.code= '';
                this.success= false;
                this.error= '';
                this.type= 'email';
                this.visiable= false;
                this.showCount= true;
                this.time= 60;
                this.registerSuccess= false;
            },
            changeVisiable() {
                this.visiable = !this.visiable;
            },
            turnToModal(param) {
                // 这里会闪一下，并且右边滑动条不会消失
                for(var modal in this.showObj) {
                    this.showObj[modal] = false;
                }
                this.showObj[param] = true;
            },
            check () {
                var phone = /^1\d{10}$/;
                var mail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                if (phone.test(this.email)) {
                    this.type = 'phone';
                } else if (mail.test(this.email)) {
                    this.checkMail();
                    this.type = 'email';
                } else {
                    this.error = '请输入合法的手机号或邮箱';
                }
            },
            checkMail () {
                axios.post('/api/user/exist/email', {
                    email: this.email
                }).then((res) => {
                    if (res.data.code == 0) {
                        this.error = '';
                    } else {
                        this.error = '邮箱已存在';
                    }
                })
                .catch(() => {})
            },
            equal () {
                if (this.password.length < 8) {
                    this.error = '密码过短';
                    return;
                }
                if (this.password.length > 18) {
                    this.error = '密码过长';
                    return;
                }
                if (this.password !== this.confirm) {
                    this.error = '两次输入的密码不相符';
                } else {
                    this.error = '';
                }
            },
            submit (times) {
                var that = this;
                if(times > 1) {
                    that.time = 60;
                    that.showCount = true;
                }
                var data = {
                    email: this.email,
                    password: this.password
                }
                user.register(this.type, data).then((res) => {
                    if (res.data.code === 0) {
                        this.success = true;
                        this.countDown();
                    }
                })
                .catch(function (e) {
                })
            },
            confirmAccount() {
                var that = this;
                var data = {
                    email: this.email,
                    code: this.code
                }
                var url = this.type === 'email' ? '/api/user/confirm/email' : '/api/user/confirm/phone';
                axios.post(url, data).then(function (response) {
                    console.log(response.data);
                    if(response.data.code === 0) {
                        that.success = false;
                        that.registerSuccess = true;
                    }else {
                        that.error = response.data.message
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            countDown() {
                var that = this;
                var timer = setInterval(function() {
                    that.time--;
                    if(that.time === 0) {
                        clearInterval(timer);
                        that.showCount = false;
                    }
                }, 1000);
            },
            jumpEmail() {
                window.location.href = this.email;
            }
        }
    }
</script>

<style lang="scss">
    $maincolor: #0666b2;
    .el-dialog.el-dialog--small {
        width: 620px;
        height: 684px;
        cursor: auto;
    }
    .modal-title {
        margin-top: 107px;
        font-size: 24px;
        line-height: 1;
        color: #000;
        text-align: center;
    }
    .el-dialog__wrapper {
        cursor: url('http://www.evhui.com/wp-content/themes/evhui3.0/public/images/cursor.png'), auto;
    }
    .form {
        &>div {
            margin-top: 40px;
        }
        input {
            display: block;
            width: 460px;
            height: 40px;
            margin: 0 auto 30px;
            padding: 12px 0 12px 10px;
            font-size: 16px;
            color: #999;
            line-height: 1;
            box-sizing: border-box;
            border-radius: 4px;
        }
        .ipt {
            border: 1px solid #ccc;
        }
        .btn {
            cursor: pointer;
        }
        .btn-solid {
            border: none;
            background-color: $maincolor;
            color: #fff;
        }
        .btn-hollow {
            border: 1px solid $maincolor;
            color: $maincolor;
            background-color: #fff;
        }
    }
    .modal-footer {
        display: flex;
        justify-content: space-between;
        width: 460px;
        margin: 0 auto;
        color: $maincolor;
        a {
            color: $maincolor;
        }
    }
    .btn-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 50px;
        height: 50px;
        background-color: #999;
        background-image: url('http://www.evhui.com/wp-content/themes/evhui3.0/public/images/cursor.png');
        background-repeat: no-repeat;
        background-size: 22px;
        background-position: 14px 14px;
        cursor: pointer;
        &:hover {
            background-color: #f00;
        }
    }
    .ipt-wrap {
        position: relative;
        i {
            position: absolute;
            top: 15px;
            right: 72px;
            width: 16px;
            height: 10px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
            background-image: url("../../../static/img/visiable-ok.png");
            cursor: pointer;
        }
        .text-icon {
            background-image: url("../../../static/img/visiable-no.png");
        }
    }
    .verify-wrap {
        position: relative;
        span {
            position: absolute;
            top: 13px;
            right: 71px;
            font-size: 16px;
            color: #999;
        }
        .resend {
            color: $maincolor;
            cursor: pointer;
        }
    }
    .register-success {
        .success-tip {
            position: relative;
            margin-top: 177px;
            margin-bottom: 50px;
            padding-left: 32px;
            text-align: center;
            font-size: 24px;
            color: #000;
            &:before {
                content: "";
                position: absolute;
                top: 1px;
                left: 38%;
                width: 24px;
                height: 24px;
                background-image: url("../../../static/img/success.svg");
                background-size: 100%;
                background-repeat: no-repeat;
            }
        }
        .success-email {
            margin-bottom: 30px;
            font-size: 16px;
            color: #000;
            text-align: center;
        }
        .success-resend {
            margin-top: 181px;
            font-size: 16px;
            color: #000;
            text-align: center;
            span {
                color: #3f3f3f;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Register.vue?33dcbd5c